import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import BannerCaldas from '../components/BannerCaldas';
import Sponsors from '../components/Sponsors';
import MenuCaldas from '../components/MenuCaldas';
import '../assets/styles/containers/SimpleSection.sass';

class SimpleSectionCaldas extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      data: {},
      slug: ''
    }
  }
  
  componentDidMount() {
    const {slug} = this.props.match.params;
    this.getData(slug);
  }

  componentWillReceiveProps(nextProps) {
    const {slug} = this.props.match.params;
    if(slug !== nextProps.match.params.slug) {
      this.getData(nextProps.match.params.slug);
    }
 }

  getData(slug) {
    fetch(`${process.env.REACT_APP_URL}/general-caldas/${slug}`)
    .then(res => res.json())
    .then(
      (res) => {
        this.setState({data: res});
        this.getBannerFoto(slug);
      },
      (error) => {
        this.setState({error: error});
      }
    )
    return;
  }

  getBannerFoto(slug) {
    switch (slug) {
      case 'conviertete-en-patrocinador':
        this.setState({slug: 'conviertete-en-patrocinador'});
        break;
      case 'informacion-de-la-expo':
        this.setState({slug: 'informacion-de-la-expo'});
        break;
      case 'precios-que-incluye':
        this.setState({slug: 'precios-que-incluye'});
        break;
      default:
        this.setState({slug: ''});
        break;
    }
  }

  
  render() {
    const {data} = this.state;
    const {content, sponsors} = data;
    return (
      <Layout>
        <>
          <BannerCaldas id={13} city="caldas" thumb="/caldas/logo_caldas.png" picture={this.state.slug === 'precios-que-incluye' ? '' : this.state.slug}/>
          <MenuCaldas />
          <div className="row content-caldas">

            {ReactHtmlParser(content?.content_es)}

          </div>
          {sponsors &&
            <Sponsors
              customClass="--caldas"
              items={sponsors}
            />
          }
        </>
      </Layout>
    );
  }
}

export default SimpleSectionCaldas;
